$('.product-slider').slick({
      autoplay: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      arrows: false,
        asNavFor: '.product-slider-thumbnail'
    });
    $('.product-slider-thumbnail').slick({
      autoplay: false,
      prevArrow:"<img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/64493759def9a9d727f61f73/64494c721d360dd5fb0a316f_arrow-prev.svg'>",
  		nextArrow:"<img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/64493759def9a9d727f61f73/64494c72e3011acd11462c6a_arrow-next.svg'>",
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product-slider',
      dots: false,
      arrows: true,
      focusOnSelect: true,
      variableWidth: false,
       responsive: [
      {
      breakpoint: 480,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
    });
 $('input[data-slide]').click(function() {
   var slideno = $(this).data('slide');
   $('.product-slider-thumbnail').slick('slickGoTo', slideno - 1);
 });
// 
$(document).ready(function() {
    $('label.bundle-field').click(function() {
        $('label.bundle-field').removeClass('bundle-active');
        $(this).addClass('bundle-active');
    });
});
// 
$(document).ready(function() {
    $('.variants_list_1 label.style-field').click(function() {
        $('.variants_list_1 label.style-field').removeClass('style-active');
        $(this).addClass('style-active');
    });
  $('.variants_list_2 label.style-field').click(function() {
        $('.variants_list_2 label.style-field').removeClass('style-active');
        $(this).addClass('style-active');
    });
  $('.variants_list_3 label.style-field').click(function() {
        $('.variants_list_3 label.style-field').removeClass('style-active');
        $(this).addClass('style-active');
    });
  $('.variants_list_4 label.style-field').click(function() {
        $('.variants_list_4 label.style-field').removeClass('style-active');
        $(this).addClass('style-active');
    });
   $('.variants_list_5 label.style-field').click(function() {
        $('.variants_list_5 label.style-field').removeClass('style-active');
        $(this).addClass('style-active');
    });
   $('.variants_list_6 label.style-field').click(function() {
        $('.variants_list_6 label.style-field').removeClass('style-active');
        $(this).addClass('style-active');
    });
});
// 
$('label.purchase-field').click(function(e) { $(this).toggleClass('.purchase-active'); }); 

// Add single product on checkbox check start
$(document).ready(function() {
  $("#checkbox").change(function() {
    if(this.checked) {
        //console.log('Checkbox is checked');
        var ID = $('#checkbox').val(); 
        console.log(ID);
        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: ID,
          quantity: 1
        },
          dataType: 'json', 
         success: function (data) {
           jQuery.getJSON('/cart.js', function(cart) {
                $('#CartCount span:first').text(data.quantity);
                console.log(data.quantity);
                });
         } 
         });

    }
  });
// Add single product on checkbox check end


//   // Custom Code For Bundle start

  
//  $('label.bundle-field').click(function() {
//   var active_b = $('.bundle-active input');
//   // console.log(active_b , 'active_b===============>');
//    var data_value = active_b.attr('data-value');
//     // console.log(data_value , 'data_value============================>');
//    var div_data_two = $('.bundle_two').attr('data-number');
//      var div_data_three = $('.bundle_three').attr('data-number');
//    var div_data_four = $('.bundle_four').attr('data-number');
//   // console.log(div_data_three, 'div_data_three--------------------->');
//   // console.log(div_data_two, 'div_data_two--------------------->');
//    var one_bundle = $('.bundle-field').hasClass('bundle-active');
//    // console.log(one_bundle , 'one_bundle---------------------------->');
//     if(data_value == div_data_two){
//       $('.bundle_two').addClass('show'); 
//       $('.bundle_three').removeClass('show');
//       $('.bundle_four').removeClass('show');
//     }
//     else if (data_value == div_data_three){
//       $('.bundle_two').removeClass('show'); 
//       $('.bundle_four').removeClass('show'); 
//       $('.bundle_three').addClass('show'); 
//     }
//     else if (data_value == div_data_four){
//       $('.bundle_two').removeClass('show'); 
//       $('.bundle_three').removeClass('show'); 
//       $('.bundle_four').addClass('show'); 
//     }
//     else if (one_bundle == true){
//       $('.bundle_two').removeClass('show'); 
//     }
//     else{
//       console.log('not match');
//     }
//  });




// //  Code for adding 2 products start
// $(".bundle-field").click(function() {
//   var active = $('.bundle_two').hasClass('show');
//   if(active == true){
//     console.log('hellooooooo');
  
// $('.btn-cart-box').click(function(){
//   setTimeout(function(){ 
//   var blank_array = [];
//   // console.log('Clickkkkkkkkkkk------->');
//   var first_v = $('.variants_list_1 .style-active').attr('variant_id');   
//    blank_array.push(first_v);
  
//   // console.log(first_v , 'first_v-----------------<>');
//   // console.log(second_v , 'second_v-----------------<>');
//      $.ajax({
//           type: 'POST',
//           url: '/cart/add.js',
//           data: {
//             items: [
//               {
//                 id: blank_array[0],
//                 quantity: 1
//               }
//             ]
//           },
//             dataType: 'json', 
//            success: function (data) {
//              jQuery.getJSON('/cart.js', function(cart) {
//                   $('#CartCount span:first').text(data.items.quantity);
//                   console.log(data.items.quantity);
//                   });
//            } 
//            });
//     // 
//       },300);
//    document.dispatchEvent(new CustomEvent('cart:refresh', {
//               bubbles: true,
//           })); 
//   });
// }
// });
// //  Code for adding 2 products end

// //  Code for adding 3 products start
// $(".bundle-field").click(function() {
//   var active = $('.bundle_three').hasClass('show');
//   if(active == true){
//     // console.log('hellooooooo');
  
// $('.btn-cart-box').click(function(){
//   setTimeout(function(){ 
//   var blank_array = [];
//   // console.log('Clickkkkkkkkkkk------->');
  
//   var first_v = $('.variants_list_2 .style-active').attr('variant_id');   
//    var second_v = $('.variants_list_3 .style-active').attr('variant_id'); 

//    blank_array.push(first_v);
//    blank_array.push(second_v);
//    // console.log(blank_array[1] , "array");
  
//   // console.log(first_v , 'first_v-----------------<>');
//   // console.log(second_v , 'second_v-----------------<>');
//      $.ajax({
//           type: 'POST',
//           url: '/cart/add.js',
//           data: {
//             items: [
//               {
//                 id: blank_array[0],
//                 quantity: 1
//               },
//               {
//                 id: blank_array[1],
//                 quantity: 1
//               }
//             ]
//           },
//             dataType: 'json', 
//            success: function (data) {
//              jQuery.getJSON('/cart.js', function(cart) {
//                   $('#CartCount span:first').text(data.items.quantity);
//                   console.log(data.items.quantity);
//                   });
//            } 
//            });
//     //  
//       },300);
//   document.dispatchEvent(new CustomEvent('cart:refresh', {
//               bubbles: true,
//           })); 
//   });
// }
// });
// //  Code for adding 3 products end
//   // Code for adding 4 product start
//   $(".bundle-field").click(function() {
//   var active = $('.bundle_four').hasClass('show');
//   if(active == true){
//     console.log('hellooooooo');
  
// $('.btn-cart-box').click(function(){
//   setTimeout(function(){ 
//   var blank_array = [];
//   console.log('Clickkkkkkkkkkk------->');
  
//   var first_v = $('.variants_list_4 .style-active').attr('variant_id');   
//   var second_v = $('.variants_list_5 .style-active').attr('variant_id'); 
//   var third_v = $('.variants_list_6 .style-active').attr('variant_id'); 
//   blank_array.push(first_v);
//   blank_array.push(second_v);
//   blank_array.push(third_v);
//   // console.log(blank_array[2] , "array");
  
//   // console.log(first_v , 'first_v-----------------<>');
//   // console.log(second_v , 'second_v-----------------<>');
//      $.ajax({
//           type: 'POST',
//           url: '/cart/add.js',
//           data: {
//             items: [
//               {
//                 id: blank_array[0],
//                 quantity: 1
//               },
//               {
//                 id: blank_array[1],
//                 quantity: 1
//               },
//               {
//                 id: blank_array[2],
//                 quantity: 1
//               }
//             ]
//           },
//             dataType: 'json', 
//            success: function (data) {
//              jQuery.getJSON('/cart.js', function(cart) {
//                   $('#CartCount span:first').text(data.items.quantity);
//                   console.log(data.items.quantity);
//                   });
//            } 
//            });
//     // 
//       },300);
//     document.dispatchEvent(new CustomEvent('cart:refresh', {
//         bubbles: true,
//     })); 
//   });
// }
// });

// // Set data start
// $('.variants_list_1 input').change(function(){
//   var discount_price = $('.variants_list_1 .style-active').attr('price'); 
//   var compare_price = $('.variants_list_1 .style-active').attr('compare_price'); 
//   var set_att = $('.price__container').find('.header-product-price-old');
//   var set_price = $('.price__container').find('.price-item--sale');
//   set_att.html(discount_price);
//   set_price.html(compare_price);
// });
// $('.variants_list_2 input').change(function(){
//   var discount_price = $('.variants_list_2 .style-active').attr('price'); 
//   var compare_price = $('.variants_list_2 .style-active').attr('compare_price'); 
//   var set_att = $('.price__container').find('.header-product-price-old');
//   var set_price = $('.price__container').find('.price-item--sale');
//   set_att.html(discount_price);
//   set_price.html(compare_price);
// });
//   $('.variants_list_3 input').change(function(){
//   var discount_price = $('.variants_list_3 .style-active').attr('price'); 
//   var compare_price = $('.variants_list_3 .style-active').attr('compare_price'); 
//   var set_att = $('.price__container').find('.header-product-price-old');
//   var set_price = $('.price__container').find('.price-item--sale');
//   set_att.html(discount_price);
//   set_price.html(compare_price);
// });
// $('.variants_list_4 input').change(function(){
//   var discount_price = $('.variants_list_4 .style-active').attr('price'); 
//   var compare_price = $('.variants_list_4 .style-active').attr('compare_price'); 
//   var set_att = $('.price__container').find('.header-product-price-old');
//   var set_price = $('.price__container').find('.price-item--sale');
//   set_att.html(discount_price);
//   set_price.html(compare_price);
// });
//   $('.variants_list_5 input').change(function(){
//   var discount_price = $('.variants_list_5 .style-active').attr('price'); 
//   var compare_price = $('.variants_list_5 .style-active').attr('compare_price'); 
//   var set_att = $('.price__container').find('.header-product-price-old');
//   var set_price = $('.price__container').find('.price-item--sale');
//   set_att.html(discount_price);
//   set_price.html(compare_price);
// });
//   $('.variants_list_6 input').change(function(){
//   var discount_price = $('.variants_list_6 .style-active').attr('price'); 
//   var compare_price = $('.variants_list_6 .style-active').attr('compare_price'); 
//   var set_att = $('.price__container').find('.header-product-price-old');
//   var set_price = $('.price__container').find('.price-item--sale');
//   set_att.html(discount_price);
//   set_price.html(compare_price);
// });
// // Set data end
});




